import { Injectable } from '@angular/core';
import { HttpService } from '../providers/http.service';

import { AppConfig } from '../app/app.config';

@Injectable()
export class NormalReportService {
    constructor(
        private httpService: HttpService
    ) { }

    //获取常规投注信息
    //TQQ 2016-12-29
    getNormalReport(params: any) {
        return this.httpService.get(AppConfig.GetProdUrl() + "/Report/Comm", params);
    }

    //获取订单详情
    //TQQ 2017-01-02
    getOrderDetail(bettingId: string,type: number) {
        let param = "bettingId=" + bettingId;
        let url = "";
        url = (type == 0) ? AppConfig.GetProdUrl() + "/Report/GetOrderDetail" : AppConfig.GetProdUrl() + "/Lottery/QueryKQBettingModel";
        return this.httpService.get(url + "?" + param);
    }

    //撤单
    //TQQ 2017-02-22
    revocationCommand(bettingId: number,type: number) {
        let param = "btIssueId=" + bettingId;
        let url = "";
        // param = (type == 0) ? "btIssueId=" + bettingId : "btIssueId=" + bettingId; 
        url = (type == 0) ? AppConfig.GetProdUrl() + "/Lottery/RevocationCommand" : AppConfig.GetProdUrl() + "/Lottery/KQWFRevocateIssue";
        return this.httpService.get(url + "?" + param);
    }

    //全部撤单
    //TQQ 2017-02-23
    allrevocationCommand(ModeType: number,bettingId: number) {
        let param = "bettingId=" + bettingId;
        let url = "";
        url = (ModeType == 0) ? AppConfig.GetProdUrl() + "/Lottery/AllRevocationCommand" : AppConfig.GetProdUrl() + "/Lottery/KQWFRevocateOrder" ;
        return this.httpService.get(url + "?" + param);
    }
}


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./src/services/normalreport.service.ts